import React from 'react';
import { Avatar, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import { filterArrayEqual } from '../../functions/arrays';
import DynamicIcon from '../Complements/DynamicIcon';
import { useSelector } from 'react-redux';

const ShowValidators = props => {
    const {dataValidators} = props
    const states = useSelector((state) => state.states);
    // const user = useSelector((state) => state.user);

    return (
        <div>
            <List>
                {
                    dataValidators.map(dv => {
                        const {body} = dv
                        const bdy = JSON.parse(body)
                        const state = states.find(s => s.id === dv.state)
                        console.log(filterArrayEqual(states, 'id', dv.state))
                        return <ListItem button onClick={() => console.log('clic')}>
                                    <ListItemAvatar>
                                        <Avatar>{'$'}</Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                    style={{maxWidth: '80%'}}
                                        primary={<span>{`${bdy.nombre} ${bdy.primerApellido ? bdy.primerApellido : ''} ${bdy.segundoApellido ? bdy.segundoApellido : ''}`}</span>}
                                        secondary={<span>{state.name}</span>}
                                    />
                                    <ListItemSecondaryAction>
                                        {
                                            // dv.state === 1 && dv.cedule !== user.identification ?
                                            //     <Button
                                            //         variant="outlined" 
                                            //         // disabled = {openSecondDialog}
                                            //         style= {{ backgroundColor:'#8EAB40'}}
                                            //         onClick={() => {
                                            //             // setLoading(true)
                                            //             // setPayrollerSelecter(payroller)
                                            //             // setOpenSecondDialog(true)
                                            //             // setLoading(false)
                                            //     } } >Solicitar Aprobación</Button> :
                                                <DynamicIcon iconName={filterArrayEqual(states, 'id', dv.state)[0].icon} />
                                        }
                                    </ListItemSecondaryAction>
                                </ListItem>
                    })
                }
                
            </List>
        </div>
    );
};

ShowValidators.propTypes = {
    
};

export default ShowValidators;